import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}attendance/admin/`;

export default {
  stats(params = {}) {
    return axios.get(`${API_URL}stats`, {
      params,
      headers: buildHeaders(),
    });
  },
};
